'use client';

import { Header } from '@components/layout/Header/Header';
import { BottomNav } from '@components/layout/BottomNav';
import { ReactNode } from 'react';
import { NavbarTheme } from 'src/types/header-types';
import { useClearCacheOnUserChange } from '@hooks/useSwrApi';
import { HeaderSearchContextProvider } from '@components/contexts/HeaderSearchContext';


// Interface
// ******************************************
interface LayoutDefaultProps {
  children?: ReactNode,
  navbarTheme?: NavbarTheme,
}

/**
 * @description Default layout. It renders the header and the mobile bottom navigation.
 * - children - The children to render inside the layout.
 * - navbarTheme - The theme of the navbar, 'default' | 'transparent'.
 *
 * @example
 * // if you want a transparent header, pass the navbarTheme prop
 * MyPage.getLayout = function getLayout(page: ReactNode) {
 *   return (
 *     <LayoutDefault navbarTheme="transparent">
 *       {page}
 *     </LayoutDefault>
 *   );
 * };
 */
export const LayoutDefault = function LayoutFunction(props: LayoutDefaultProps) {
  // Destructure props
  const {
    children,
    navbarTheme,
  } = props;

  // Check if we should revalidate SWR cache on tab refocus
  useClearCacheOnUserChange();


  return (
    <HeaderSearchContextProvider>
      {/* Place all the sticky top banners in Header component */}
      <Header navbarTheme={navbarTheme} />
      {children}
      <BottomNav />
    </HeaderSearchContextProvider>
  );
};
